export const PROMOTION_CUSTOMER_TYPE = 'PROMOSYON';
export const LEGACY_DEMO_CUSTOMER_TYPE = 'DEMO';

export function isPromotionCustomerType(type: string): boolean {
  return type === PROMOTION_CUSTOMER_TYPE || type === LEGACY_DEMO_CUSTOMER_TYPE;
}

/**
 * DEMO is the persisted legacy spelling. Keep accepting it on reads, but use
 * PROMOSYON for every value sent by the current UI.
 */
export function canonicalCustomerType(type: string): string {
  return type === LEGACY_DEMO_CUSTOMER_TYPE ? PROMOTION_CUSTOMER_TYPE : type;
}
